"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostVoteFromJSON = PostVoteFromJSON;
exports.PostVoteFromJSONTyped = PostVoteFromJSONTyped;
exports.PostVoteToJSON = PostVoteToJSON;
exports.PostVoteToJSONTyped = PostVoteToJSONTyped;
const runtime_1 = require("../runtime");
function PostVoteFromJSON(json) {
    return PostVoteFromJSONTyped(json, false);
}
function PostVoteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'voteId': !(0, runtime_1.exists)(json, 'voteId') ? undefined : json['voteId'],
        'answerId': !(0, runtime_1.exists)(json, 'answerId') ? undefined : json['answerId'],
    };
}
function PostVoteToJSON(value) {
    return PostVoteToJSONTyped(value, false);
}
function PostVoteToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'voteId': value.voteId,
        'answerId': value.answerId,
    };
}
